export default __webpack_public_path__ + "static/media/icon-third-hc.3f220193.svg";